import {  
    Box, 
    Hidden, 
    Stack, 
    Typography } from "@mui/material"
import { useTranslation } from "react-i18next";
import SignInButton from "../components/login/SignInButton";
import AppleIcon from "@mui/icons-material/Apple";
import AndroidIcon from "@mui/icons-material/Android";
import Footer from "../components/layout/Footer";
import LoginLayout from "../components/layout/LoginLayout";

export default function WelcomePage(){

    const {t} = useTranslation();

    return (
    <div>
    <LoginLayout />
    <Box display="flex" alignItems="center" justifyContent="center" height="100vh">
            <Stack alignItems="center" justifyContent="space-between" spacing={10}> 
            <Stack alignItems="center" justifyContent="center" spacing={2}>
                <Typography variant="h1" align="center">
                    {t("Welcome to")}
                </Typography>
                <Typography variant="h1" align="center">
                    {t("Mobile Application Distribution")}
                </Typography>
                <Hidden mdDown>
                    <Stack direction="row" alignItems="center" justifyContent="center" spacing={2}>
                    <AppleIcon color="action" sx={{  width: 80, height: 80 }}/> 
                    <AndroidIcon color="action" sx={{  width: 80, height: 80 }}/> 
                    </Stack>
                </Hidden>
                <Hidden mdUp>
                    <Stack direction="row" alignItems="center" justifyContent="center" spacing={2}>
                        <AppleIcon color="action" sx={{ width: 40, height: 40 }}/> 
                        <AndroidIcon color="action" sx={{ width: 40, height: 40 }}/> 
                    </Stack>
                </Hidden>
                </Stack>
                <SignInButton />
            </Stack>
        </Box>
        <div
            style={{
            position: "absolute",
            left: 0,
            bottom: 0,
            right: 0
            }}
        >
            <Footer />    
        </div> 
    </div>);
}